import React, { useEffect, useState } from 'react';
import { MapPin, Phone, ExternalLink, Building2 } from 'lucide-react';
import { Badge } from './ui/badge';
import { api } from '../lib/api';

export const ProviderList = ({ programId }) => {
  const [providers, setProviders] = useState(null);

  useEffect(() => {
    api.get(`/programs/${programId}/providers`).then(({ data }) => setProviders(data.providers)).catch(() => setProviders([]));
  }, [programId]);

  if (providers === null) return <p className="text-sm text-muted-foreground">Loading providers…</p>;
  if (!providers.length) return null;

  return (
    <div data-testid={`providers-${programId}`} className="space-y-2">
      <div className="text-sm font-semibold flex items-center gap-1.5"><Building2 className="w-4 h-4 text-primary" /> Local providers &amp; referral agencies (Toronto)</div>
      <div className="grid sm:grid-cols-2 gap-2">
        {providers.map((pr) => (
          <div key={pr.name} className="rounded-lg border border-border bg-background p-3 text-sm" data-testid="provider-card">
            <div className="flex items-start justify-between gap-2">
              <div className="font-medium leading-snug">{pr.name}</div>
              <Badge variant="outline" className="shrink-0 text-[10px]">{pr.type}</Badge>
            </div>
            <div className="text-xs text-muted-foreground mt-1.5 flex items-center gap-1"><MapPin className="w-3 h-3" /> {pr.address}</div>
            <div className="text-xs mt-1 flex items-center gap-3 flex-wrap">
              <a href={`tel:${pr.phone.replace(/[^0-9+]/g, '')}`} className="flex items-center gap-1 text-primary underline"><Phone className="w-3 h-3" /> {pr.phone}</a>
              <a href={pr.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-primary underline">Website <ExternalLink className="w-3 h-3" /></a>
            </div>
            <p className="text-xs text-foreground/70 mt-1.5">{pr.note}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Listings are public information. Please confirm current ADP registration and intake status before visiting.</p>
    </div>
  );
};
